import {WARRANTY_EXPIRY_LIST} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const WarrantyRoutes: IAppRoutes = {
  link: WARRANTY_EXPIRY_LIST,
  childrens: [
    {
      link: WARRANTY_EXPIRY_LIST,
      element: guard(() => import('@modules/asset/WarrantyExpiry'), [WARRANTY_EXPIRY_LIST]),
    },
  ],
}
